// 🚨 Routes publiques (clients) — une seule liste, partagée par App.js, AuthContext et PermissionsContext.
export const PREFIXES_ROUTES_PUBLIQUES = [
  '/soumission/', '/mot-de-passe-oublie', '/reinitialiser-mot-de-passe', '/accepter-invitation',
  '/decharge/', '/ajout-public/', '/facture/', '/facture-lmds/', '/presentation/',
];

export function isPublicRoute(pathname) {
  const p = pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
  return PREFIXES_ROUTES_PUBLIQUES.some((prefix) => p.startsWith(prefix));
}
